(() => {
  const variants = {
    info: { title: 'À savoir', icon: 'info' },
    tip: { title: 'Conseil', icon: 'tip' },
    order: { title: 'Commande', icon: 'order' },
    delivery: { title: 'Livraison', icon: 'delivery' },
    important: { title: 'Important', icon: 'important' }
  };

  function enhanceCallout(block) {
    if (block.dataset.lgCalloutReady === 'true') return;

    const variantName = variants[block.dataset.variant] ? block.dataset.variant : 'info';
    const variant = variants[variantName];
    let content = block.querySelector('.lg-callout__content');

    if (!content) {
      content = document.createElement('div');
      content.className = 'lg-callout__content';

      while (block.firstChild) {
        content.appendChild(block.firstChild);
      }

      block.appendChild(content);
    }

    if (!content.querySelector('.lg-callout__title')) {
      const title = document.createElement('p');
      title.className = 'lg-callout__title';
      title.textContent = block.dataset.title || variant.title;
      content.insertBefore(title, content.firstChild);
    }

    if (!block.querySelector('.lg-callout__icon')) {
      const template = document.querySelector('[data-lg-callout-icon="' + variant.icon + '"]');

      if (template) {
        const icon = document.createElement('span');
        icon.className = 'lg-callout__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.appendChild(template.content.cloneNode(true));
        block.insertBefore(icon, content);
      }
    }

    block.setAttribute('role', 'note');
    block.dataset.lgCalloutReady = 'true';
  }

  function initCallouts(root) {
    const scope = root || document;
    scope.querySelectorAll('.lg-callout').forEach(enhanceCallout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCallouts());
  } else {
    initCallouts();
  }
})();
